// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__115kw","filesListContainer":"PosDisputesFiles_filesListContainer__eFv9N","filesButton":"PosDisputesFiles_filesButton__2Gf_i"};